/**
 * Синтез метронома.
 *
 * Тики генерируются напрямую в AudioBuffer ЖИВОГО AudioContext (без OfflineAudioContext,
 * WAV-конвертации, Blob и decodeAudioData): клик = sin(2π·f·t)·exp(-20t), t < 50 мс,
 * с интервалом 60/bpm. Меньше задержка старта и нет браузерно-зависимых сбоев
 * на промежуточных этапах.
 *
 * Акцент: при заданном beatsPerMeasure сильная доля каждого такта звучит
 * вдвое выше и громче (880 Гц при frequency 440) — как на механических метрономах.
 */
export const createMetronomeBuffer = (
  audioContext,
  duration,
  bpm,
  { frequency = 440, beatsPerMeasure = 0 } = {}
) => {
  const sampleRate = audioContext.sampleRate;
  const length = Math.max(1, Math.round(duration * sampleRate));
  const buffer = audioContext.createBuffer(1, length, sampleRate);
  const data = buffer.getChannelData(0);

  const clickLength = Math.floor(sampleRate * 0.05); // 50 мс
  const intervalSamples = Math.max(1, Math.round((60 / bpm) * sampleRate));

  let beatIndex = 0;
  for (let offset = 0; offset < length; offset += intervalSamples, beatIndex++) {
    const accented = beatsPerMeasure > 0 && beatIndex % beatsPerMeasure === 0;
    const f = accented ? frequency * 2 : frequency;
    const amp = accented ? 1 : 0.8;
    const remaining = Math.min(clickLength, length - offset);
    for (let i = 0; i < remaining; i++) {
      const t = i / sampleRate;
      data[offset + i] = Math.sin(t * f * 2 * Math.PI) * Math.exp(-t * 20) * amp;
    }
  }

  return buffer;
};
